import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Button, Icon, Confirm, Form, Grid } from 'semantic-ui-react';

import { StatusList, SearchInputBox, Pagerow, Pagination, TableForm } from 'components/Commons';
import { ResendModal } from './Modal';

import * as com_action from 'actions/company';

import cm from 'helpers/commons';
import toastr from 'helpers/toastr';

class RequestedList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      //confirm
      open: false,
      //confirm ok btn
      text: null,
      type: null,

      page: 1
    };
  }

  componentWillMount() {
    const { comAPI } = this.props;

    //회원가입 요청내역 상태리스트
    comAPI.signupStatus();
    //회원가입 요청 내역
    //this.requestedListSel();
  }

  handleEntSubmit = (e) => {
    if (e.key === 'Enter') {
      this.requestedListSel('search');
    }
  };

  //사용자 회원가입 요청내역 불러오기
  requestedListSel = (type) => {
    const { page } = this.state,
      { pageRow, statusStr, text } = this.props,
      params = {
        keyword: text ? text.value : null,
        status: statusStr ? statusStr.value : null,
        page: type === 'search' ? 1 : page,
        pagerow: pageRow ? pageRow.value : 10
      };

    const { comAPI } = this.props;
    comAPI.requestList(params);
  };

  //회원가입 요청내역 페이지 클릭
  pageClick = async (page) => {
    await this.setState({ page: page });
    this.requestedListSel();
  };

  openModal = ({ text, type, groupidx }) => {
    this.setState({
      open: true,
      text: text,
      type: type,
      groupidx: groupidx
    });
  };

  handleConfirm = () => {
    const { groupidx } = this.state;

    this.setState({ open: false });
    this.resendLink(groupidx);
  };

  handleCancel = () => {
    this.setState({
      open: false,
      text: null,
      type: null
    });
  };

  // 링크 취소
  onCancelLink = async (cancelIdx) => {
    const { comAPI } = this.props;

    try {
      await comAPI.cancelLink(cancelIdx);
      this.requestedListSel();
      toastr('top-right', 'success', '취소 되었습니다.');
    } catch (e) {
      console.log('###### error : ', e);
      toastr('top-right', 'error', '일시적인 오류로 링크 취소를 하지 못했습니다. 다시 시도해주세요.');
    }
  };

  //링크 재전송
  resendLink = async (groupidx) => {
    const { text, type } = this.state,
      { groupNum } = this.props.RequestedListFn;

    const params = {
      resend: {
        value: {
          text: text,
          type: type
        },
        groupidx: groupidx
      }
    };

    const { comAPI } = this.props;
    let status = null;
    try {
      await comAPI.resendLink(params);
    } catch (e) {
      if (e.response && e.response.data) {
        status = e.response.data.status;
      }
    }

    const { resend } = this.props;
    if (resend.status === 200) {
      this.requestedListSel();
      toastr('top-right', 'success', '전송 되었습니다.');

      this.setState({
        text: null,
        type: null
      });
    } else {
      if (status === -1100) {
        toastr(
          'top-right',
          'error',
          '지정된 식대그룹이 변경되어 재전송할 수 없습니다. Step1에서 다시 식대그룹을 지정하여 새로운 회원가입 링크를 전송해주세요.'
        );
      } else {
        toastr('top-right', 'error', '일시적인 오류로 링크 재전송을 하지 못했습니다. 다시 시도해주세요.');
      }
    }
  };

  render() {
    const { open, page, pagerow } = this.state,
      { status, reqList } = this.props,
      modalFn = {
        open: open,
        cancel: this.handleCancel,
        confirm: this.handleConfirm
      };
    //   ,
    // { requestedListSel,
    //   pageClick } = this.props.RequestedListFn;

    let p_page = page,
      p_pagerow = pagerow,
      p_totalcount = 0,
      requestList,
      tabledata = {
        header: {
          main: [
            { data: '#', textAlign: 'left' },
            { data: '링크전송 시각', textAlign: 'left' },
            { data: '링크 만료 시각', textAlign: 'left' },
            { data: '휴대전화번호 or 이메일', textAlign: 'left' },
            { data: '식대그룹', textAlign: 'left' },
            { data: '아이디', textAlign: 'left' },
            { data: '상태', textAlign: 'left' },
            { data: ' ', textAlign: 'left' },
            { data: '링크재전송' }
          ]
        },
        body: {
          message: '회원가입 요청내역이 존재하지 않습니다.',
          main: null
        }
      };

    if (reqList) {
      if (reqList.data) {
        const { paging, send } = reqList.data;

        if (paging) {
          p_page = paging.page;
          p_pagerow = paging.pagerow;
          p_totalcount = paging.totalcount;
        }

        if (send) {
          const length = send.length;
          tabledata.body.main = send.map((item, index) => {
            let valueText = '-';
            if (item.value.type === 'phone') {
              valueText = cm.phoneFormat(item.value.text);
            } else if (item.value.type === 'email') {
              valueText = item.value.text;
            }

            let btnText = '-',
              btnFunc = '',
              btnData = '',
              cancelBtnText = '',
              cancelBtnFunc = '',
              cancelBtnData = '',
              btnProps = '';

            if (item.status.value === 'READY' || item.status.value === 'CANCEL') {
              btnText = '링크재전송';
              btnFunc = this.openModal;
              btnData = { text: item.value.text, type: item.value.type, groupidx: item.group.idx };

              if (item.status.value === 'READY') {
                cancelBtnText = '취소';
                cancelBtnFunc = this.onCancelLink;
                cancelBtnData = { cancelIdx: item.signupUserIdx };
              } else {
                btnProps = { disabled: true, style: { background: '#ddd' } };
              }
            }

            let groupName = '-';
            if (item.group) {
              groupName = item.group.name;
              groupName += item.group.isActive ? '' : '(사용불가)';
            }

            let obj = {
              row: [
                {
                  data: item.idx,
                  textAlign: 'left'
                },
                {
                  data: cm.yyyyMMdd(new Date(item.senddate)) + ' ' + cm.hhmmss(new Date(item.senddate)),
                  textAlign: 'left'
                },
                {
                  data: cm.yyyyMMdd(new Date(item.expiredate)) + ' ' + cm.hhmmss(new Date(item.expiredate)),
                  textAlign: 'left'
                },
                {
                  data: valueText,
                  textAlign: 'left'
                },
                {
                  data: groupName,
                  textAlign: 'left'
                },
                {
                  data: item.signid ? item.signid : '-',
                  textAlign: 'left'
                },
                {
                  data: item.status.text,
                  textAlign: 'left',
                  width: 70
                },
                {
                  data: cancelBtnText,
                  btnData: cancelBtnData,
                  btnFunc: cancelBtnFunc,
                  width: 100
                },
                {
                  data: btnText,
                  btnFunc: btnFunc,
                  btnData: btnData,
                  btnProps: btnProps
                }
              ]
            };
            return obj;
          });
        }
      } else {
        // if(reqList.response.status === 500) {
        //
        //   const { data } = reqList.response;
        // requestList = (
        //   <Table.Row>
        //     <Table.Cell colSpan={7} textAlign='center'>
        //       {data.message}
        //     </Table.Cell>
        //   </Table.Row>
        // );
        //}
      }
    }

    return (
      <div className="list-box">
        <div className="list-title">
          <span>회원가입 요청내역</span>
        </div>

        <div className="list-content">
          <Form>
            <Grid className="top-form">
              <Grid.Column className="form-left">
                <Grid.Row>
                  <Form.Group inline>
                    <Pagerow onChangeFn={(e) => this.requestedListSel('search')} />
                    <StatusList status={status} onChangeFn={(e) => this.requestedListSel('search')} />
                    <SearchInputBox
                      handleSubmit={(e) => this.requestedListSel('search')}
                      placeHolder={'이메일, 휴대전화번호'}
                      handleEntSubmit={this.handleEntSubmit}
                    />
                  </Form.Group>
                </Grid.Row>
              </Grid.Column>
            </Grid>
          </Form>

          <div className="table-box">
            <TableForm
              //scroll = {true}
              //columnWidth = {[100, 155, 155, 150, 120, 120, 140]}
              tabledata={tabledata}
            />
          </div>

          <div className="table-paging">
            <Pagination
              page={p_page}
              pageRow={p_pagerow}
              pageBlock={10}
              totalCount={p_totalcount}
              pageClick={this.pageClick}
            />
          </div>
        </div>

        <ResendModal modalFn={modalFn} />
      </div>
    );
  }
}

RequestedList = connect(
  (state) => ({
    //data
    status: state.company.data,
    reqList: state.company.requested,
    resend: state.company.resend,

    //form
    pageRow: state.commons.pagerow,
    statusStr: state.commons.statusStr,
    text: state.commons.text
  }),
  (dispatch) => ({
    comAPI: bindActionCreators(
      {
        signupStatus: com_action.SignupStatus,
        requestList: com_action.RequestedList,
        resendLink: com_action.ResendLink,
        cancelLink: com_action.CancelLink
      },
      dispatch
    )
  })
)(RequestedList);

export default RequestedList;
